import { Navigate, Route, Routes } from "react-router-dom";

import { AppShell } from "./components/AppShell";
import { RequireAuth } from "./components/RequireAuth";
import { DashboardPage } from "./pages/DashboardPage";
import { HomePage } from "./pages/HomePage";
import { InventoryPage } from "./pages/InventoryPage";
import { LaunchPage } from "./pages/LaunchPage";
import { LoginPage } from "./pages/LoginPage";
import { OrderDetailPage } from "./pages/OrderDetailPage";
import { ProfilePage } from "./pages/ProfilePage";
import { PublicReceiptPage } from "./pages/PublicReceiptPage";
import { RecommendationsPage } from "./pages/RecommendationsPage";
import { ReportsPage } from "./pages/ReportsPage";
import { SalePage } from "./pages/SalePage";
import { TransactionsPage } from "./pages/TransactionsPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* V0080 - customer-facing receipt page. Public, no auth.
       *  Slug is the access check; lookup miss returns 404 from the
       *  underlying public endpoint and the page renders a friendly
       *  empty state.  Lives outside the AppShell tree so the cashier
       *  chrome (sidebar, profile menu) doesn't render for customers. */}
      <Route path="/r/:slug" element={<PublicReceiptPage />} />
      {/* D1 - Partner SSO launch deep-link. Public, no auth required.
       *  Exchanges the partner-minted launch token for Cognito tokens,
       *  stores them, and redirects to /sale (or ?return_to=). */}
      <Route path="/launch" element={<LaunchPage />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/" element={<HomePage />} />
        <Route path="/sale" element={<SalePage />} />
        <Route path="/transactions" element={<TransactionsPage />} />
        <Route path="/transactions/:id" element={<OrderDetailPage />} />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/insights" element={<RecommendationsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
